import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  SUBMIT_SERVICE_CHANGE_DETAILS_FAILED,
  SUBMIT_SERVICE_CHANGE_DETAILS_FULFILLED,
  SUBMIT_SERVICE_CHANGE_DETAILS_PENDING,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"
import { MOCK_SERVICE_CHANGE_INFORMATION } from "utils-lib/mocks"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const pendingAC = () => ({
  type: SUBMIT_SERVICE_CHANGE_DETAILS_PENDING,
})

export const failedAC = () => ({
  type: SUBMIT_SERVICE_CHANGE_DETAILS_FAILED,
})

export const fulfilledAC = (data) => ({
  type: SUBMIT_SERVICE_CHANGE_DETAILS_FULFILLED,
  payload: data,
})

export const submitServiceChangeDetails =
  ({ customerId, payload }) =>
  (dispatch, getState) => {
    const api = `SERVICE_CHANGE_SUBMIT`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const mockJsonFile = `${ssrWindow.origin}/mock/submit-service-change-details-response.json`

    const url = MOCK_SERVICE_CHANGE_INFORMATION
      ? mockJsonFile
      : template.expand({
          userId: get(state, `userAccount.userDetails.userId`, ``),
          customerId,
          lang: get(state, `siteLanguage.language`, ``),
        })
    const data = {
      ...payload,
    }
    const config = {
      method: `POST`,
      headers: {},
      data,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      return submitServiceChangeDetailsHelper(url, config, dispatch, data)
    })
  }

export const submitServiceChangeDetailsHelper = (
  url,
  config,
  dispatch,
  data,
) => {
  dispatch(pendingAC())
  return axios
    .create(config)
    .post(url, data)
    .then((response) => {
      const data = get(response, "data.data", {})
      dispatch(fulfilledAC(data))
      return data
    })
    .catch((error) => {
      dispatch(failedAC())
      return error.response.status
    })
}
